import { Tag, TagLeftIcon, Text } from '@chakra-ui/react';
import { AIInsightVerdict } from '../../types';
import { useAiVerdictBadge } from '../../hooks';

export interface AiVerdictBadgeProps {
  verdict: AIInsightVerdict;
}

/**
 * Renders an AI verdict as a colored badge with appropriate icon.
 */
export const AiVerdictBadge = ({
  verdict,
}: AiVerdictBadgeProps): JSX.Element => {
  const { bgColor, label, icon, borderColor } = useAiVerdictBadge(verdict);

  return (
    <Tag
      size="sm"
      bg={bgColor}
      border={borderColor ? '1px solid' : ''}
      borderColor={borderColor}
    >
      <TagLeftIcon as={icon} boxSize={3} color="white" />
      <Text color="white">{label}</Text>
    </Tag>
  );
};
